import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthorizationService } from '../services/authorization/authorization.service';

@Injectable()
export class AuthorizationGuard implements CanActivate {

  constructor(private authorizationService: AuthorizationService,
              private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {

    // check for User

    return this.authorizationService.getAuthorization$()
      .pipe(
        take(1),
        map(hasUser => {
          if (hasUser) {
            return true;
          }
          this.router.navigateByUrl('login').then();
          return false;
        })
      );
  }
}


